export default __webpack_public_path__ + "static/media/VihatTechnologies.ea9c6caf.png";